import { createContext } from 'react'

/**
 * When true, step actions offered beside the step's main action, such as
 * starting an extension, collapse into a menu instead of rendering as buttons.
 */
export const CollapseSecondaryActionsContext = createContext(false)
